import React from "react";
import { FormattedMessage } from "react-intl";
import { graphql } from "gatsby";
import { List, Grid } from "semantic-ui-react";
import { OutboundLink } from "gatsby-plugin-google-gtag";
import { GatsbyImage } from "gatsby-plugin-image";
import HighLightSection from "../components/highlight-section";
import Layout from "../components/layout";
import { FormattedHTMLMessage } from "../components/hooks/use-intlh";
import {
  Email,
  Twitter,
  Facebook,
  Youtube,
  TwitterFollowButton,
  Address,
} from "../components/social";

const FounderCard = ({ image, fullName, keyName, twitterBtn, style = {} }) => (
  <div
    style={{
      display: "flex",
      flexDirection: "column",
      padding: "1rem",
      width: "fit-content",
      alignItems: "center",
      ...style,
    }}
  >
    <GatsbyImage
      title={fullName}
      alt={fullName}
      image={image}
      className="founder-img"
    />

    <span style={{ fontWeight: "bolder" }}>
      <FormattedMessage id={`company.who-are-we.${keyName}.part1`} />
    </span>
    <span style={{ fontStyle: "italic" }}>
      <FormattedMessage id={`company.who-are-we.${keyName}.part2`} />
    </span>
    <span>
      <FormattedMessage
        id={`company.who-are-we.${keyName}.part3`}
        values={{
          twitter_btn: twitterBtn,
        }}
      />
    </span>
  </div>
);

const IndexPage = ({
  pageContext: { language, title, id },
  data,
}) => (
  <Layout
    locale={language}
    title={title}
    pageId={id}
  >
    <div>
      <HighLightSection
        title={<FormattedMessage id="company.title" />}
        subTitle={<FormattedMessage id="company.sub-title" />}
      />
      <Grid stackable>
        <Grid.Column width={10}>
          <h2>
            <FormattedMessage id="company.who-are-we.title" />
          </h2>
          <p>
            <FormattedHTMLMessage id="company.who-are-we.content.part1" />
          </p>

          <div style={{ display: "flex",  width:"100%", justifyContent: "space-around", flexWrap: "wrap"}}>
            <FounderCard
              fullName="Jean-Christophe Baey"
              keyName="jcbaey"
              twitterBtn={<TwitterFollowButton account="jcbaey" />}
              image={data.imageJcBaey.childImageSharp.gatsbyImageData}
             
            />

            <FounderCard
              fullName="Benoist Jamin"
              keyName="bjamin"
              image={data.imageBenoistJamin.childImageSharp.gatsbyImageData}
            />
          </div>

          <p>
            <FormattedMessage
              id="company.who-are-we.content.part2"
            />
          </p>
          <p>
            <FormattedMessage
              id="company.who-are-we.content.part3"
              values={{
                link: (
                  <OutboundLink href="https://startups.microsoft.com">
                    Microsoft for Startups
                  </OutboundLink>
                ),
              }}
            />
            .
          </p>
          <GatsbyImage
            alt="Microsoft logo"
            image={data.imageMicrosoft.childImageSharp.gatsbyImageData}
          />
        </Grid.Column>
        <Grid.Column width={6}>
          <h2>
            <FormattedMessage id="company.contact-us" />
          </h2>
          <h3>
            <FormattedMessage id="company.email.title" />
          </h3>
          <p>
            <FormattedMessage id="company.email.content" />
          </p>
          <Email icon />
          <h3>
            <FormattedMessage id="company.postal-address" />
          </h3>
          <p>
            <Address />
          </p>
          <h3>
            <FormattedMessage id="company.social-medias" />
          </h3>

          <List link>
            <Twitter className="item" />
            <Facebook className="item" />
            <Youtube className="item" />
          </List>
        </Grid.Column>
        <Grid.Column width={10}>
          <h2>
            <FormattedMessage id="company.legal-information" />
          </h2>
          <h4>LEARNPULSE SAS</h4>
          <p>
            <FormattedMessage id="company.company-type" />
          </p>
          <h4>
            <FormattedMessage id="company.registration-number" />
          </h4>
          <p>750 658 007 RCS TOULOUSE FRANCE</p>
          <h4>
            <FormattedMessage id="company.capital" />
          </h4>
          <p>15 000 Euros</p>
          <h4>
            <FormattedMessage id="company.headquarters" />
          </h4>
          <p>
            <Address />
          </p>
          <h4>
            <FormattedMessage id="company.siret" />
          </h4>
          <p>75065800700018</p>
          <h4>
            <FormattedMessage id="company.vat" />
          </h4>
          <p>FR14750658007</p>
        </Grid.Column>
      </Grid>
    </div>
  </Layout>
);

export default IndexPage;

export const query = graphql`
  query companyEnglishPageQuery {
    imageJcBaey: file(
      relativePath: { eq: "components/author/images/jcbaey.jpg" }
    ) {
      publicURL
      childImageSharp {
        gatsbyImageData(layout: CONSTRAINED, placeholder: DOMINANT_COLOR)
      }
    }

    imageBenoistJamin: file(
      relativePath: { eq: "components/author/images/bjamin.jpg" }
    ) {
      publicURL
      childImageSharp {
        gatsbyImageData(layout: CONSTRAINED, placeholder: DOMINANT_COLOR)
      }
    }

    imageMicrosoft: file(
      relativePath: { eq: "pages/company/microsoft_logo.png" }
    ) {
      publicURL
      childImageSharp {
        gatsbyImageData(
          layout: CONSTRAINED
          width: 100
          placeholder: DOMINANT_COLOR
        )
      }
    }
  }
`;
